export const environment = {
	production: true,
    api_server: 'https://marketplace.smartees.eu/api/',
    google_map_api_key: 'AIzaSyDhQx0ykXBmdBvJuOwxWVDUhCWuy3UMeKA',
};
